export type SimpleAndRegularFilterOptions = {
  name: string;
  key: string;
  filterType: string;
  options: string[];
};
export type ComplexFilterOptions = {
  name: string;
  key?: string;
  filterType: string;
  options: {
    [key: string]: {
      [key: string]: string[];
    };
  };
};

interface FilterOptionsTypes {
  [key: string]: SimpleAndRegularFilterOptions | ComplexFilterOptions;
}

export const VEHICLE_TYPE_OPTIONS = {
  name: 'type',
  key: 'vehicleType',
  filterType: 'simple',
  options: ['new', 'cpo'],
};

export const REGION_QUERY_OPTIONS = {
  name: 'region',
  key: 'offerRegion',
  filterType: 'regular',
  options: ['GTA', 'MTL', 'VAN', 'ALB', 'NAT'],
};

export const TYPE_QUERY_OPTIONS = {
  name: 'offer-type',
  key: 'offerType',
  filterType: 'regular',
  options: ['lease', 'finance', 'bonus'],
};

export const CARLINE_GROUP_QUERY_OPTIONS = {
  name: 'carline-group',
  key: 'modelFamily',
  filterType: 'complex',
  options: {
    a3: {
      modelFamily: ['a3', 's3', 'rs3'],
    },
    a4: {
      modelFamily: ['a4', 's4'],
    },
    a5: {
      modelFamily: ['a5', 's5', 'rs5'],
    },
    a6: {
      modelFamily: ['a6', 's6', 'rs6'],
    },
    a7: {
      modelFamily: ['a7', 's7', 'rs7'],
    },
    a8: {
      modelFamily: ['a8', 's8'],
    },
    q3: {
      modelFamily: ['q3'],
    },
    q4: {
      modelFamily: ['q4etron'],
    },
    q5: {
      modelFamily: ['q5', 'sq5'],
    },
    q6: {
      modelFamily: ['q6etron', 'sq6etron'],
    },
    q7: {
      modelFamily: ['q7', 'sq7'],
    },
    q8: {
      modelFamily: ['q8', 'sq8', 'rsq8', 'q8etron', 'sq8etron'],
    },
    q9: {
      modelFamily: ['q9', 'sq9'],
    },
    tt: {
      modelFamily: ['tt', 'tts', 'ttrs'],
    },
    r8: {
      modelFamily: ['r8'],
    },
    etron: {
      modelFamily: ['etron', 'etrongt', 'rsetrongt', 'q4etron', 'q8etron', 'sq8etron'],
    },
    etrongt: {
      modelFamily: ['etrongt', 'rsetrongt'],
    },
  },
};
export const CARLINE_QUERY_OPTIONS = {
  name: 'carline',
  filterType: 'complex',
  options: {
    a3limo: {
      modelFamily: ['a3'],
      bodyType: ['sedan'],
    },
    s3limo: {
      modelFamily: ['s3'],
      bodyType: ['sedan'],
    },
    rs3limo: {
      modelFamily: ['rs3'],
      bodyType: ['sedan'],
    },
    // A4
    a4limo: {
      modelFamily: ['a4'],
      bodyType: ['sedan'],
    },
    a4aq: {
      modelFamily: ['a4'],
      bodyType: ['allroad quattro'],
    },
    s4limo: {
      modelFamily: ['s4'],
      bodyType: ['sedan'],
    },
    // A5
    a5new: {
      modelFamily: ['a5new'],
    },
    a5coupe: {
      modelFamily: ['a5'],
      bodyType: ['coupe'],
    },
    a5sb: {
      modelFamily: ['a5'],
      bodyType: ['sportback'],
    },
    a5cabrio: {
      modelFamily: ['a5'],
      bodyType: ['cabriolet'],
    },
    a5limo: {
      modelFamily: ['a5'],
      bodyType: ['sedan'],
    },
    s5coupe: {
      modelFamily: ['s5'],
      bodyType: ['coupe'],
    },
    s5new: {
      modelFamily: ['s5new'],
    },
    s5sb: {
      modelFamily: ['s5'],
      bodyType: ['sportback'],
    },
    s5cabrio: {
      modelFamily: ['s5'],
      bodyType: ['cabriolet'],
    },
    s5limo: {
      modelFamily: ['s5'],
      bodyType: ['sedan'],
    },
    rs5coupe: {
      modelFamily: ['rs5'],
      bodyType: ['coupe'],
    },
    rs5sb: {
      modelFamily: ['rs5'],
      bodyType: ['sportback'],
    },
    // A6
    a6limo: {
      modelFamily: ['a6'],
      bodyType: ['sedan'],
    },
    a6etron: {
      modelFamily: ['a6etron'],
    },
    a6aq: {
      modelFamily: ['a6'],
      bodyType: ['allroad quattro'],
    },
    s6limo: {
      modelFamily: ['s6'],
      bodyType: ['sedan'],
    },
    s6etron: {
      modelFamily: ['s6etron'],
      bodyType: ['sedan'],
    },
    rs6avant: {
      modelFamily: ['rs6'],
      bodyType: ['avant'],
    },
    // A7
    a7sb: {
      modelFamily: ['a7'],
      bodyType: ['sportback'],
    },
    s7sb: {
      modelFamily: ['s7'],
      bodyType: ['sportback'],
    },
    rs7sb: {
      modelFamily: ['rs7'],
      bodyType: ['sportback'],
    },
    // A8
    a8l: {
      modelFamily: ['a8'],
      bodyType: ['sedan'],
    },
    s8l: {
      modelFamily: ['s8'],
      bodyType: ['sedan'],
    },
    // Q3
    q3: {
      modelFamily: ['q3'],
      bodyType: ['suv'],
    },
    // Q4
    q4: {
      modelFamily: ['q4etron'],
    },
    q4etron: {
      modelFamily: ['q4etron'],
      bodyType: ['suv'],
    },
    q4sbetron: {
      modelFamily: ['q4etron'],
      bodyType: ['sportback'],
    },
    // Q5
    q5new: {
      modelFamily: ['q5new'],
      bodyType: ['suv'],
    },
    q5: {
      modelFamily: ['q5'],
      bodyType: ['suv'],
    },
    q5sb: {
      modelFamily: ['q5'],
      bodyType: ['sportback'],
    },
    q5etron: {
      modelFamily: ['q5e'],
      bodyType: ['suv'],
      fuelType: ['gasoline_hybrid'],
    },
    q5tfsie: {
      modelFamily: ['q5e'],
      bodyType: ['suv'],
      fuelType: ['gasoline_hybrid'],
    },
    sq5new: {
      modelFamily: ['sq5new'],
      bodyType: ['suv'],
    },
    sq5: {
      modelFamily: ['sq5'],
      bodyType: ['suv'],
    },
    sq5sb: {
      modelFamily: ['sq5'],
      bodyType: ['sportback'],
    },
    q6etron: {
      modelFamily: ['q6etron'],
      bodyType: ['suv'],
    },
    q6sbetron: {
      modelFamily: ['q6etron'],
      bodyType: ['sportback'],
    },
    sq6etron: {
      modelFamily: ['sq6etron'],
      bodyType: ['suv'],
    },
    sq6sbetron: {
      modelFamily: ['sq6etron'],
      bodyType: ['sportback'],
    },
    // Q7
    q7: {
      modelFamily: ['q7'],
      bodyType: ['suv'],
    },
    sq7: {
      modelFamily: ['sq7'],
      bodyType: ['suv'],
    },
    // Q8
    q8: {
      modelFamily: ['q8'],
      bodyType: ['suv'],
    },
    q8etron: {
      modelFamily: ['q8etron'],
      bodyType: ['suv'],
    },
    sq8etron: {
      modelFamily: ['sq8etron'],
      bodyType: ['suv'],
    },
    q8sbetron: {
      modelFamily: ['q8etron'],
      bodyType: ['sportback'],
    },
    sq8sbetron: {
      modelFamily: ['sq8etron'],
      bodyType: ['sportback'],
    },
    sq8: {
      modelFamily: ['sq8'],
      bodyType: ['suv'],
    },
    rsq8: {
      modelFamily: ['rsq8'],
      bodyType: ['suv'],
    },
    // Q9
    q9: {
      modelFamily: ['q9'],
      bodyType: ['suv'],
    },
    sq9: {
      modelFamily: ['sq9'],
      bodyType: ['suv'],
    },
    // etron
    etron: {
      modelFamily: ['etron'],
      bodyType: ['suv'],
    },
    etrons: {
      modelFamily: ['etron'],
      bodyType: ['sportback'],
    },
    etronsb: {
      modelFamily: ['etron'],
      bodyType: ['sportback'],
    },
    // etron GT
    etrongt: {
      modelFamily: ['etrongt'],
      // bodyType: ['limousine'],
    },
    rsetrongt: {
      modelFamily: ['rsetrongt'],
      // bodyType: ['limousine'],
    },
    // TT
    ttcoupe: {
      modelFamily: ['tt'],
      bodyType: ['coupe'],
    },
    ttroadster: {
      modelFamily: ['tt'],
      bodyType: ['roadster'],
    },
    ttscoupe: {
      modelFamily: ['tts'],
      bodyType: ['coupe'],
    },
    ttrscoupe: {
      modelFamily: ['ttrs'],
      bodyType: ['coupe'],
    },
    // R8
    r8: {
      modelFamily: ['r8'],
      bodyType: ['coupe'],
    },
    r8spyder: {
      modelFamily: ['r8'],
      bodyType: ['spyder'],
    },
    r8performance: {
      modelFamily: ['r8'],
      bodyType: ['coupe'],
    },
    r8spyderperformance: {
      modelFamily: ['r8'],
      bodyType: ['spyder'],
    },
  },
};
export const BODY_STYLE_QUERY_OPTIONS = {
  name: 'bodyType',
  key: 'bodyType',
  filterType: 'regular',
  options: [
    'suv',
    'sedan',
    'limousine',
    'allroad_quattro',
    'coupe',
    'sportback',
    'spyder',
    'roadster',
    'cabriolet',
    'sportscar',
    'avant',
  ],
};
export const TRIMLINE_QUERY_OPTIONS = {
  name: 'trimline',
  key: 'trimLine',
  filterType: 'regular',
  options: [
    'premium',
    'premium_plus',
    'prestige',
    'other',
    'e-tron_quattro',
    'e-tron_quattro_progressiv',
    'e-tron_quattro_technik',
    '45_e-tron_rwd',
    '45_tfsi_quattro',
    '55_e-tron_quattro',
    '55_tfsi_quattro',
    '55_tfsi_quattro_progressiv',
    '55_tfsi_quattro_technik',
    'sq8_quattro',
    'quattro',
    'tfsi_quattro',
    'tfsi_quattro_progressiv',
    'tfsi_quattro_technik',
    'tfsi_quattrotechnik', // potential RFC data entry error
    'quattro_progressiv',
    '45_tfsi_quattro_komfort',
    '40_tfsi_quattro_komfort',
  ],
};

export const YEAR_QUERY_OPTIONS = {
  name: 'year',
  key: 'modelYear',
  filterType: 'regular',
  options: ['2023', '2024', '2025', '2026', '2027'],
};

export const QUERY_FILTERS_OPTIONS: FilterOptionsTypes = {
  region: REGION_QUERY_OPTIONS,
  type: VEHICLE_TYPE_OPTIONS,
  'offer-type': TYPE_QUERY_OPTIONS,
  'carline-group': CARLINE_GROUP_QUERY_OPTIONS,
  carline: CARLINE_QUERY_OPTIONS,
  'body-style': BODY_STYLE_QUERY_OPTIONS,
  trimline: TRIMLINE_QUERY_OPTIONS,
  year: YEAR_QUERY_OPTIONS,
};
